import React from 'react';
import { connect } from "react-redux";
//import {Alert} from "antd";

//import actions

//component imports
import SetLanguage from "./cards/SetLanguage";

class Settings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            profile: this.props.profile,
        };
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.profile !== this.props.profile) {
            this.setState({ profile: nextProps.profile })
        }

    }


    checkUserAccess() {
        //extract state
        const { profile } = this.state;

        const access = profile.userAccess.some(access => access === "settings");

        if (access) {
            return (
                <div>
                    <div>
                        <h4>App Settings</h4>

                        <div>
                            <SetLanguage/>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <h2>You have no access</h2>
        }
    }

    render(){
        return (
            <div className={"settingsContainer"}>

                { this.checkUserAccess() }
            </div>
        )
    }
}

const mapStateToProps = state => {

    const { profile } = state.profile;

    return {
        profile,
    }
};

export default connect(mapStateToProps, { })(Settings);
